export default "__VITE_ASSET__pcTaURl1__"